(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ma-hero-image-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ma-image-hero')) {
    customElements.define('ma-image-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.toggleButton = this.querySelector('[data-toggle]');
        this.index = 0;
        this.paused = false;
        this.userPaused = false;
        this.step = this.dataset.direction === 'rtl' ? -1 : 1;
        this.dataset.enhanced = 'true';
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - this.step));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + this.step));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? this.step : -this.step));
        });
        this.addEventListener('pointerenter', () => { this.paused = true; });
        this.addEventListener('pointerleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });
        this.addEventListener('pointerdown', (event) => { this.startX = event.clientX; });
        this.addEventListener('pointerup', (event) => {
          if (this.startX == null) return;
          const delta = event.clientX - this.startX;
          if (Math.abs(delta) > 45) this.show(this.index + (delta < 0 ? this.step : -this.step));
          this.startX = null;
        });
        this.toggleButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.toggleButton.setAttribute('aria-pressed', String(this.userPaused));
          this.toggleButton.setAttribute('aria-label', this.toggleButton.dataset[this.userPaused ? 'labelPlay' : 'labelPause']);
          this.toggleButton.querySelector('[data-pause-glyph]').hidden = this.userPaused;
          this.toggleButton.querySelector('[data-play-glyph]').hidden = !this.userPaused;
        });
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduced && this.slides.length > 1) {
          this.timer = setInterval(() => { if (!this.paused && !this.userPaused) this.show(this.index + this.step); }, Number(this.dataset.interval) || 6000);
        }
      }
      disconnectedCallback() { clearInterval(this.timer); }
      show(next) {
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; slide.classList.toggle('is-active', index === this.index); });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
